export { default } from './HeadControlPanel'
